
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wikipedia-to-flashcards",
      function () {
        return require("private-next-pages/wikipedia-to-flashcards.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wikipedia-to-flashcards"])
      });
    }
  